export function convertToNumberWithDecimal(val?: any, decimalNumber = 3): string {
  if (val !== undefined && val !== null) {
    const options = {
      style: 'decimal',
      useGrouping: false,
      // minimumFractionDigits: decimalNumber,
      maximumFractionDigits: decimalNumber
    };
    return  val.toLocaleString(undefined, options);
  } else {
    return '';
  }
}
